var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50025 9.9996L9.16675 11.6663L12.4997 8.33288M16.666 10.8333C16.666 15.0001 13.7496 17.0835 10.2833 18.2919C10.1018 18.3534 9.90462 18.3505 9.72503 18.2836C6.25038 17.0835 3.334 15.0001 3.334 10.8333V4.99982C3.334 4.7788 3.42179 4.56683 3.57805 4.41054C3.73432 4.25426 3.94626 4.16646 4.16725 4.16646C5.83375 4.16646 7.91687 3.16642 9.36673 1.89972C9.54326 1.74888 9.76782 1.666 10 1.666C10.2322 1.666 10.4567 1.74888 10.6333 1.89972C12.0915 3.17476 14.1662 4.16646 15.8327 4.16646C16.0537 4.16646 16.2657 4.25426 16.4219 4.41054C16.5782 4.56683 16.666 4.7788 16.666 4.99982V10.8333Z",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.e4fdd582bef05df5d46b208d1dc624e6.svg";
export { ForwardRef as ReactComponent };